export const CLIENTS = [
  {
    name: 'oporto' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'identification hampsta' },
          { name: 'identification generic' },
          { name: 'membership subway' },
          { name: 'communication main nz' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'update member details generic' },
          { name: 'icash topup' },
          { name: 'icash topup reversal' },
          { name: 'icash redemption' },
          { name: 'icash redemption reversal' },
          { name: 'icash donation' },
          { name: 'icash donation refund' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'credit allocation' },
          { name: 'credit allocation refund' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: 'bank accounts' }, { name: 'bank accounts create' }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'voucher',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'AU', currency: 'AUD' }],
  },
  {
    name: 'redrooster' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'identification hampsta' },
          { name: 'identification generic' },
          { name: 'membership subway' },
          { name: 'communication main nz' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'update member details generic' },
          { name: 'icash topup' },
          { name: 'icash topup reversal' },
          { name: 'icash redemption' },
          { name: 'icash redemption reversal' },
          { name: 'icash donation' },
          { name: 'icash donation refund' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'credit allocation' },
          { name: 'credit allocation refund' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: 'bank accounts' }, { name: 'bank accounts create' }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'voucher',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'AU', currency: 'AUD' }],
  },
  {
    name: 'chickentreat' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'identification hampsta' },
          { name: 'identification generic' },
          { name: 'membership subway' },
          { name: 'communication main nz' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'update member details generic' },
          { name: 'icash topup' },
          { name: 'icash topup reversal' },
          { name: 'icash redemption' },
          { name: 'icash redemption reversal' },
          { name: 'icash donation' },
          { name: 'icash donation refund' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'credit allocation' },
          { name: 'credit allocation refund' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: 'bank accounts' }, { name: 'bank accounts create' }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'voucher',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'AU', currency: 'AUD' }],
  },
  {
    name: 'columbuscoffee' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'identification hampsta' },
          { name: 'identification generic' },
          { name: 'membership subway' },
          { name: 'communication' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'update member details' },
          { name: 'icash topup' },
          { name: 'icash topup reversal' },
          { name: 'icash redemption' },
          { name: 'icash redemption reversal' },
          { name: 'icash donation' },
          { name: 'icash donation refund' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'credit allocation' },
          { name: 'credit allocation refund' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'voucher',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'NZ', currency: 'NZD' }],
  },
  {
    name: 'hampsta' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'voucher' },
          { name: 'offer' },
          { name: 'identification' },
          { name: 'identification generic' },
          { name: 'membership subway' },
          { name: 'communication' },
          { name: 'update member details generic' },
          { name: 'purchase' },
          { name: 'purchase reversal' },
          { name: 'purchase redemption' },
          { name: 'purchase redemption reversal' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'loyalty redemption' },
          { name: 'loyalty redemption reversal' },
          { name: 'loyalty allocation' },
          { name: 'loyalty allocation reversal' },
          { name: 'e-voucher redemption' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'bulk transactions',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'files',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'NZ', currency: 'NZD' }],
  },
  {
    name: 'generic' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'generic',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'voucher' },
          { name: 'offer' },
          { name: 'identification' },
          { name: 'identification hampsta' },
          { name: 'membership subway' },
          { name: 'communication' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'purchase' },
          { name: 'purchase reversal' },
          { name: 'purchase redemption' },
          { name: 'purchase redemption reversal' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'loyalty redemption' },
          { name: 'loyalty redemption reversal' },
          { name: 'loyalty allocation' },
          { name: 'loyalty allocation reversal' },
          { name: 'e-voucher redemption' },
          { name: 'update member details' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'bulk transactions',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'files',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'NZ', currency: 'NZD' }],
  },
  {
    name: 'paperplus' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'offer' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'identification hampsta' },
          { name: 'identification generic' },
          { name: 'membership subway' },
          { name: 'communication' },
          { name: 'update member details' },
          { name: 'icash topup' },
          { name: 'icash topup reversal' },
          { name: 'icash redemption' },
          { name: 'icash redemption reversal' },
          { name: 'icash donation' },
          { name: 'icash donation refund' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'purchase redemption' },
          { name: 'purchase redemption reversal' },
          { name: 'credit allocation' },
          { name: 'credit allocation refund' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'voucher',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'NZ', currency: 'NZD' }],
  },
  {
    name: 'countdown' as const,
    userTypeNames: ['super_user', 'display_user', 'report_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'voucher' },
          { name: 'offer' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'identification hampsta' },
          { name: 'identification generic' },
          { name: 'membership subway' },
          { name: 'communication' },
          { name: 'update member details generic' },
          { name: 'purchase' },
          { name: 'purchase reversal' },
          { name: 'purchase redemption' },
          { name: 'purchase redemption reversal' },
          { name: 'loyalty redemption' },
          { name: 'loyalty redemption reversal' },
          { name: 'loyalty allocation' },
          { name: 'loyalty allocation reversal' },
          { name: 'credit allocation' },
          { name: 'credit allocation refund' },
          { name: 'e-voucher redemption' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'files',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'NZ', currency: 'NZD' }],
  },
  {
    name: 'westfield' as const,
    userTypeNames: ['super_user', 'display_user', 'support_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'voucher' },
          { name: 'offer' },
          { name: 'identification' },
          { name: 'identification hampsta' },
          { name: 'membership subway' },
          { name: 'communication' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'purchase' },
          { name: 'purchase reversal' },
          { name: 'purchase redemption' },
          { name: 'purchase redemption reversal' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'loyalty redemption' },
          { name: 'loyalty redemption reversal' },
          { name: 'loyalty allocation' },
          { name: 'loyalty allocation reversal' },
          { name: 'update member details' },
          { name: 'credit allocation' },
          { name: 'credit allocation refund' },
          { name: 'e-voucher redemption' },
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'files',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'bulk transactions',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'NZ', currency: 'NZD' }],
  },
  {
    name: 'subway' as const,
    userTypeNames: ['super_user', 'display_user'] as const,
    type: 'loyalty',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'identification hampsta' },
          { name: 'identification generic' },
          { name: 'membership' },
          { name: 'communication main nz' },
          { name: 'bank accounts' },
          { name: 'direct payments' },
          { name: 'update member details generic' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'subsquad',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'GB', currency: 'GBP' }],
  },
  {
    name: 'farmers' as const,
    userTypeNames: [
      'super_user',
      'display_user',
      'report_user',
      'restricted_user',
    ] as const,
    type: 'generic',
    setup: [
      {
        module: 'member',
        subs: [{ name: '*' }],
        exclude: [
          { name: 'voucher' },
          { name: 'offer' },
          { name: 'identification' },
          { name: 'identification hampsta' },
          { name: 'membership subway' },
          { name: 'communication' },
          { name: 'purchase' },
          { name: 'purchase reversal' },
          { name: 'purchase redemption' },
          { name: 'purchase redemption reversal' },
          { name: 'special icash refund' },
          { name: 'special loyalty refund' },
          { name: 'loyalty redemption' },
          { name: 'loyalty redemption reversal' },
          { name: 'loyalty allocation' },
          { name: 'loyalty allocation reversal' },
          { name: 'orders westfield corp' },
          { name: 'orders westfield cons' },
          { name: 'contacts' }
        ],
      },
      {
        module: 'merchant',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'bulk transactions',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'reports',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
      {
        module: 'files',
        subs: [{ name: '*' }],
        exclude: [{ name: null }],
      },
    ],
    misc: [{ countryCode: 'NZ', currency: 'NZD' }],
  },
]

export type ClientNames = (typeof CLIENTS)[number]['name']

export type ClientUserTypeNames<C extends ClientNames> = Extract<
  (typeof CLIENTS)[number],
  { name: C }
>['userTypeNames'][number]

const CLIENT_NAME_LIST = CLIENTS.map((c) => c.name) as ClientNames[]

export function assertClientName(
  value: string | undefined
): asserts value is ClientNames {
  if (!CLIENT_NAME_LIST.includes(value as ClientNames))
    throw new Error(`Unknown client: ${value}`)
}
